import onboardingModalTagImage from 'img/freemium/benefitsModal/onboardingModalTag.png';
import onboardingModalTag7DaysImage from 'img/freemium/benefitsModal/onboardingModalTag7Days.png';
import onboardingModalTag7DaysDarkImage from 'img/freemium/benefitsModal/onboardingModalTag7DaysDark.png';
import onboardingModalTagActivatedImage from 'img/freemium/benefitsModal/onboardingModalTagActivated.png';
import onboardingModalTagActivatedDarkImage from 'img/freemium/benefitsModal/onboardingModalTagActivatedDark.png';
import onboardingModalTagDarkImage from 'img/freemium/benefitsModal/onboardingModalTagDark.png';
import balloonImageTop from 'img/freemium/onboardingBallonTop.png';
import balloonImageTopControl from 'img/freemium/onboardingBallonTopControl.png';
import { FreemiumTypes } from 'reactApp/appHelpers/featuresHelpers/features/freemium';
import type { FreemiumFeaturesModalData } from 'reactApp/sections/FamilyPage/FreemiumFeaturesModal/FreemiumFeaturesModal.types';
import styles from 'reactApp/ui/FreemiumOnboardBanner/FreemiumOnboardBanner.css';

import type { FreemiumOnboardModalProps } from './FreemiumOnboardBanner.types';

const buttonText = 'Попробовать бесплатно';

export const defaultTitle = 'Дарим безлимит для фото с телефона';
export const defaultBalloonProps: Record<FreemiumTypes, FreemiumOnboardModalProps> = {
    [FreemiumTypes.control]: {
        title: defaultTitle,
        topImage: balloonImageTopControl,
        imageClassName: styles.imageSmaller,
        buttonText: 'Попробовать за 1 ₽',
    },
    [FreemiumTypes.soft]: {
        title: defaultTitle,
        topImage: balloonImageTop,
        buttonText,
    },
    [FreemiumTypes.hard]: {
        title: defaultTitle,
        topImage: balloonImageTop,
        text: 'А ещё — все возможности пробной подписки на 7 дней',
        buttonText,
    },
};

export const defaultModalProps: Record<FreemiumTypes, FreemiumFeaturesModalData> = {
    [FreemiumTypes.control]: {
        title: 'Попробуйте безлимит для фото с телефона — в подписке Mail Space',
        text: 'Перенесите фото и видео с телефона в Облако, чтобы освободить память для нового. В Облаке галерея телефона весит 0 ГБ',
        buttonText: 'Попробовать за 1 ₽',
        tagImage: onboardingModalTagImage,
        tagImageDark: onboardingModalTagDarkImage,
    },
    [FreemiumTypes.soft]: {
        title: 'Попробуйте безлимит для фото с телефона — в пробной подписке',
        text: 'Перенесите фото и видео с телефона в Облако, чтобы освободить память для нового. В Облаке галерея телефона весит 0 ГБ',
        buttonText,
        tagImage: onboardingModalTag7DaysImage,
        tagImageDark: onboardingModalTag7DaysDarkImage,
        tagClassName: styles.softTag,
        showBankCardBlock: true,
    },
    [FreemiumTypes.hard]: {
        title: 'Безлимит в пробной подписке — ваш на 7 дней',
        text: 'Вы подключили пробную подписку. Она бесплатная, а возможности все настоящие. Пользуйтесь ей неделю — можно вместе с близкими',
        buttonText: 'Продолжить',
        tagImage: onboardingModalTagActivatedImage,
        tagImageDark: onboardingModalTagActivatedDarkImage,
        tagClassName: styles.hardTag,
        showBankCardBlock: true,
    },
};
